import { useState } from "react";
import EsVacio from "infortech_modules/Constantes/EsVacio";
import EsNumero from "infortech_modules/Constantes/EsNumero";
import Formularios from "infortech_modules/Componentes/Formularios";
import { AlertaPromesa } from "infortech_modules/Componentes/Alertas";
import Modales from "infortech_modules/Componentes/Modales";
import Boton from "infortech_modules/Componentes/Boton";
import Upload from "infortech_modules/Crud/Upload";
import { BiCommentEdit } from "react-icons/bi"
import Put from "infortech_modules/Crud/Put";
import Carga from "infortech_modules/Elementos/Carga";


export default function ModalEdit({
    tipoBotonPrincipal, IconoBotonPrincipal, SpinnerBotonPrincipal, claseIconBotonPrincipal, tituloBotonPrincipal, widthBotonPrincipal, posicionTextoBotonPrincipal,
    tipoBotonSecundario, IconoBotonSecundario, SpinnerBotonSecundario, claseIconBotonSecundario, tituloBotonSecundario, widthBotonSecundario,
    tipoBotonEnviar, IconoBotonEnviar, SpinnerBotonEnviar, claseIconBotonEnviar, tituloBotonEnviar, widthBotonEnviar,
    modalSize, modalTitulo, modalCentrado, contenidoSuperiorModal, modalAbrir, inicializarDatos, formulario, onChange, contenidoInferiorModal,
    comprobarTextoVacio, mensajeTextoVacio, numeroComprobar, mensajeNumeroComprobar, mensajeLoadingPromesa, mensajePromesa,
    nombreArchivo, archivo, rutaArchivo, recargar, principal, tipoMensajePromesa, tiempoMensajePromesa, iniciar, editar, datos1, datos2, datos3,
    id, datos4, datos5, datos6,  tabla, url, duplicados, caso, key1, small, idLog,infoLog,
    cargaMensaje, cargaAltura, cargaAnchoImagen, cargaClassNameMensaje, cargarSpiner
}) {
    tipoBotonPrincipal = tipoBotonPrincipal === undefined ? 'icono' : tipoBotonPrincipal;
    IconoBotonPrincipal = IconoBotonPrincipal === undefined ? BiCommentEdit : IconoBotonPrincipal;
    tituloBotonPrincipal = tituloBotonPrincipal === undefined ? 'Editar' : tituloBotonPrincipal;
    claseIconBotonPrincipal = claseIconBotonPrincipal === undefined ? "fs-4 pointer text-blue-700" : claseIconBotonPrincipal;

    tipoBotonSecundario = tipoBotonSecundario === undefined ? 'secondary' : tipoBotonSecundario;
    tituloBotonSecundario = tituloBotonSecundario === undefined ? 'Cerrar' : tituloBotonSecundario;

    tipoBotonEnviar = tipoBotonEnviar === undefined ? 'primary' : tipoBotonEnviar;
    tituloBotonEnviar = tituloBotonEnviar === undefined ? 'Editar' : tituloBotonEnviar;

    small = small === undefined ? true : small;
    recargar = recargar === undefined ? false : recargar;

    cargarSpiner = cargarSpiner === undefined ? false:cargarSpiner;
    comprobarTextoVacio = comprobarTextoVacio === undefined ? ["ok"]:comprobarTextoVacio;
    mensajeTextoVacio = mensajeTextoVacio === undefined ? ["ok"] : mensajeTextoVacio;

    duplicados = duplicados === undefined? {verificar:false}:duplicados;


    const [modal, setModal] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [cargar, setCargar] = useState(true);

    const open = () => {
        setModal(true);
        if (modalAbrir === undefined) {
            inicializarDatos();
            setCargar(false);
        } else {
            inicializarDatos().then((r) => {
                setCargar(false);
            });
        }
    }

    const cerrar = () => setModal(false);

    const procesar = () => {
      
        setDisabled(true);
        function activarBoton(t) {
            setTimeout(() => {
                setDisabled(false);
            }, t);
        }

        const enviarFile = () => {
            if (archivo !== undefined) {
                const promesa = new Promise((res, rej) => {
                    Upload(nombreArchivo, archivo, rutaArchivo).then((u) => {
                        editar.img = u;
                        Put(({
                            table: tabla, url: url, id: id, duplicate: duplicados, caso: caso, mensaje: mensajePromesa, reload: recargar, iniciar: iniciar,
                            data0: editar, data1: datos1, data2: datos2, data3: datos3, data4: datos4, data5: datos5, data6: datos6, key: key1, idLog:idLog, infoLog:infoLog
                        }))
                            .then((r) => {
                                mensajePromesa !== '' && setTimeout(() => {
                                    res(mensajePromesa)
                                }, 500);
                                if (!recargar) {
                                    setTimeout(() => {
                                        principal();
                                    }, 3000);
                                    setTimeout(() => {
                                        setModal(false);
                                    }, 1500);

                                }
                            }).catch((f) => {
                                setTimeout(() => {
                                    rej(f)
                                }, 500);
                            })


                    }).catch((f) => {
                        setTimeout(() => {
                            rej(f)
                        }, 500);
                    })

                });
                AlertaPromesa(mensajeLoadingPromesa, promesa, tipoMensajePromesa, tiempoMensajePromesa);

            } else {
                enviar();
            }
        }


        const enviar = () => {
            const promesa = new Promise((res, rej) => {
                Put(({
                    table: tabla, url: url, id: id, duplicate: duplicados, caso: caso, mensaje: mensajePromesa, reload: recargar, iniciar: iniciar,
                    data0: editar, data1: datos1, data2: datos2, data3: datos3, data4: datos4, data5: datos5, data6: datos6, key: key1, idLog:idLog, infoLog:infoLog
                }))
                    .then((r) => {
                        mensajePromesa !== '' && setTimeout(() => {
                            res(mensajePromesa)
                        }, 500);
                        if (!recargar) {
                            setTimeout(() => {
                                principal();
                                setDisabled(false)
                            }, 1200);
                            setTimeout(() => {
                                setModal(false);
                            }, 1500);

                        }
                    }).catch((f) => {                       
                        setTimeout(() => {
                            rej(f)                            
                        }, 500);
                        activarBoton(1000)
                    })
            })

            AlertaPromesa(mensajeLoadingPromesa, promesa, tipoMensajePromesa, tiempoMensajePromesa);
        }

        if (EsVacio(comprobarTextoVacio, mensajeTextoVacio)) {
          
            if (numeroComprobar !== undefined && mensajeNumeroComprobar !== undefined) {
                if (EsNumero(numeroComprobar, mensajeNumeroComprobar)) {
                    enviarFile()
                } else {
                    activarBoton(1250)
                }
            } else {
                enviarFile()
            }
        } else {
            activarBoton(1250)
        }

    }

    return (
        <>
            {
                <Boton tipo={tipoBotonPrincipal} Icono={IconoBotonPrincipal} SpinnerBoton={SpinnerBotonPrincipal}
                    claseIcon={claseIconBotonPrincipal} onClick={() => open()} titulo={tituloBotonPrincipal}
                    width={widthBotonPrincipal} posicionTexto={posicionTextoBotonPrincipal}
                />
            }

            <Modales
                show={modal}
                onHide={cerrar}
                size={modalSize}
                titulo={modalTitulo}
                centered={modalCentrado}
                body={
                    <>
                        {
                            cargar ? <Carga mensaje={cargaMensaje} altura={cargaAltura} anchoImagen={cargaAnchoImagen}
                                classNameMensaje={cargaClassNameMensaje} spiner={cargarSpiner} /> :
                                <>
                                    {contenidoSuperiorModal !== undefined && contenidoSuperiorModal}
                                    <div className={small && 'scaled'}>
                                        <Formularios datos={formulario} onChange={onChange} />
                                    </div>

                                    {contenidoInferiorModal !== undefined && contenidoInferiorModal}
                                </>
                        }
                    </>
                }
                footer={
                    <>

                        <Boton tipo={tipoBotonSecundario} Icono={IconoBotonSecundario} SpinnerBoton={SpinnerBotonSecundario}
                            claseIcon={claseIconBotonSecundario} onClick={() => cerrar()} titulo={tituloBotonSecundario}
                            width={widthBotonSecundario}
                        />
                        <Boton tipo={tipoBotonEnviar} Icono={IconoBotonEnviar} SpinnerBoton={SpinnerBotonEnviar}
                            claseIcon={claseIconBotonEnviar} disabled={disabled} onClick={() => procesar()} titulo={tituloBotonEnviar}
                            width={widthBotonEnviar}
                        />


                    </>
                }
            />

        </>
    )
};
